class EmployeeChangedLocationPayload {
  constructor(systemNotificationPayloadData = {}) {
    this.id = systemNotificationPayloadData.id || "";
    this.name =
      systemNotificationPayloadData.name || "";
  }
}

export default EmployeeChangedLocationPayload;
